import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

// Define a service using a base URL and expected endpoints
export const pickupApi = createApi({
    reducerPath: 'pickupApi',
    baseQuery: fetchBaseQuery({
        baseUrl: 'https://onza-api.ibm.kg/api/common/',
        prepareHeaders: (headers, { getState }) => {
            let { auth: { auth } } = getState();
            if (typeof auth == "string") {
                auth = JSON.parse(auth);
            }
            headers.set("Authorization", `Bearer ${auth?.accessToken}`);
            return headers;
        },
    }),
    tagTypes: ["Pickup"],
    endpoints: (builder) => ({
        getPickup: builder.query({
            query: () => `pickup-point-admin`,
            providesTags: ["Pickup"],
        }),
        addPickup: builder.mutation({
            query: (newPickup) => ({
                url: 'pickup',
                method: 'POST',
                body: newPickup,
            }),
            invalidatesTags: ['Pickup'],
        }),
        deletePickup: builder.mutation({
            query: ({ id }) => ({
                url: `pickup/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Pickup'],
        }),
    }),
})

export const { useGetPickupQuery, useAddPickupMutation, useDeletePickupMutation } = pickupApi